<template>
  <div id="watch" ref="watch">
    <v-container fluid>
      <v-row>
        <v-alert prominent class="mx-auto" type="error" v-if="errored">
          <v-row align="center">
            <v-col class="grow">
              <div class="title">Error!</div>
              <div>
                Something went wrong, but don’t fret — let’s give it another
                shot.
              </div>
            </v-col>
            <v-col class="shrink">
              <v-btn @click="actions">Take action</v-btn>
            </v-col>
          </v-row>
        </v-alert>
        <v-col v-else cols="11" class="mx-auto">
          <v-row>
            <v-col cols="12" sm="12" md="8" lg="8" class="px-0">
              <v-skeleton-loader
                type="card-avatar, article, actions"
                :loading="videoLoading"
                tile
                large
              >
                <div ref="hello">
                  <v-responsive>
    
                    <div class='youtube-player'>
                      <div class="iframe-player">
                    <iframe
          :src="`${getUrl}${video.embedPath}?api=1`"
          :frameBorder="0"
          allow="autoplay; fullscreen"
          allowFullScreen
          :title="`${video.name}`"
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
        ></iframe></div>
      </div>
                  </v-responsive>

                  <v-card flat tile class="card">
                    <v-card-title class="pl-0 pb-0">{{
                      video.name
                    }}</v-card-title>
                    <div
                      class="d-flex flex-wrap justify-space-between"
                      id="btns"
                    >
                      <v-card-subtitle
                        class="pl-0 pt-0 pb-0 subtitle-1"
                        style="line-height: 2.4em;"
                      >
                        {{ video.views }} views<v-icon>mdi-circle-small</v-icon
                        >{{ dateFormatter(video.createdAt) }}
                      </v-card-subtitle>
                      <v-card-actions class="pt-0 pl-0">
                        <v-btn text @click="createFeeling('like')"
                          ><v-icon
                            :class="
                              `pr-2${
                                feeling !== 'like'
                                  ? ' grey--text text--darken-1'
                                  : ''
                              }`
                            "
                            >mdi-thumb-up</v-icon
                          >{{ video.likes }}</v-btn
                        >

                        <v-btn text @click="createFeeling('dislike')"
                          ><v-icon
                            :class="
                              `pr-2${
                                feeling !== 'dislike'
                                  ? ' grey--text text--darken-1'
                                  : ''
                              }`
                            "
                            >mdi-thumb-down</v-icon
                          >
                          {{ video.dislikes }}</v-btn
                        >
                        <v-btn
                          :href="`${video.url}`"
                          text
                          class="grey--text text--darken-1"
                          ><v-icon>mdi-download</v-icon> Download</v-btn
                        >
                        <!-- <v-btn text class="grey--text text--darken-1"
                          ><v-icon>mdi-share</v-icon> Share</v-btn
                        >
                        <v-btn text class="grey--text text--darken-1"
                          ><v-icon>mdi-playlist-plus</v-icon> Save</v-btn
                        > -->
                      </v-card-actions>
                    </div>
                  </v-card>

                  <v-row class="justify-space-between">
                    <v-col cols="12" sm="6" md="5" lg="5">
                      <v-card class="transparent" flat>
                        <v-list-item three-line>
                          <v-list-item-avatar
                            v-if="typeof video.account !== 'undefined'"
                            size="50"
                          >
                            <img
                              v-if="video.account.avatars.length > 0 "
                              :src="
                                `${getUrl}${video.account.avatars[0].path}`
                              "
                              :alt="`${video.channel.displayName } avatar`"
                            />
                            <v-avatar v-else color="red">
                              <span class="white--text headline ">
                                {{
                                video.channel.displayName 
                                    .split('')[0]
                                    .toUpperCase()
                                }}</span
                              >
                            </v-avatar>
                          </v-list-item-avatar>
                          <v-list-item-content
                            v-if="typeof video.account !== 'undefined'"                   class="align-self-auto" >
                            <v-list-item-title
                              class="font-weight-medium mb-1"
                              >{{ video.channel.displayName }}</v-list-item-title
                            >
                            <v-list-item-subtitle
                              >
                              <!-- {{ video.account.id.subscribers }}  -->
                              subscribers
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <div
                        class="d-flex justify-end align-center"
                        v-if="typeof video.account !== 'undefined'">
                        <v-btn
                          v-if="currentUser && video.account !== currentUser.id"
                          :class="[
                            { 'red white--text': !subscribed },
                            {
                              'grey grey--text lighten-3 text--darken-3': subscribed
                            },
                            'mt-6'
                          ]"
                          tile
                          large
                          depressed
                          :loading="subscribeLoading"
                          @click="subscribe"
                          >{{ !subscribed ? 'subscribe' : 'subscribed' }}</v-btn
                        >

                        <v-btn
                          v-else-if="showSubBtn"
                          :class="[
                            { 'red white--text': !subscribed },
                            {
                              'grey grey--text lighten-3 text--darken-3': subscribed
                            },
                            'mt-6'
                          ]"
                          tile
                          large
                          depressed
                          :loading="subscribeLoading"
                          @click="subscribe"
                          >{{ !subscribed ? 'subscribe' : 'subscribed' }}</v-btn
                        >

                      </div>
                    </v-col>
                    <v-col class="pl-11" offset="1" cols="11" md="11">
                      <p>
                        {{ video.truncatedDescription }}
                      </p>
                      <v-btn text @click="show" class="remove-hover-bg"
                        >Show More</v-btn
                      >
                    </v-col>
                  </v-row>
                </div>
              </v-skeleton-loader>

              <v-row>
                <v-col v-if="video && video.status === 'public'">
                  <p class="mb-0">{{ video.comments }} Comments</p>

                  <AddComment
                    @videoCommentLength="video.comments++"
                    :videoId="video.shortUUID"
                  />
                  <CommentList
                    @videoCommentLength="video.comments--"
                    :videoId="video.shortUUID"
                  />
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="4">
              <hr class="grey--text" />
              <h4 class="mb-3 mt-3">Up next</h4>
              <div
                v-for="(video, i) in loading ? 12 : videos"
                :key="i"
                class="mb-5"
              >
                <v-skeleton-loader
                  class="mx-auto"
                  type="list-item-avatar-three-line"
                  :loading="loading"
                  tile
                  large
                >
                  <v-card
                    class="card"
                    tile
                    flat
                    v-if="!loading"
                    :to="`/watch/${video.shortUUID}`"
                  >
                    <v-row no-gutters>
                      <v-col class="mx-auto" cols="12" sm="12" md="5" lg="5">
                        <!-- <v-responsive max-height="100%"> -->
                        <v-img
                          class="align-center"
                          height="110"
                          :src="`${getUrl}${video.thumbnailPath}`"
                        >
                        </v-img>
                        <!-- </v-responsive> -->
                      </v-col>
                      <v-col>
                        <div class="ml-2">
                          <v-card-title
                            class="pl-2 pt-0 subtitle-1 font-weight-bold"
                            style="line-height: 1"
                          >
                            {{ video.name }}
                          </v-card-title>

                          <v-card-subtitle
                            class="pl-2 pt-2 pb-0"
                            style="line-height: 1"
                          >
                          {{ video.channel.displayName }}<br />
                            {{ video.views }} views<v-icon
                              >mdi-circle-small</v-icon
                            >
                            {{ dateFormatter(video.createdAt) }}
                          </v-card-subtitle>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-skeleton-loader>
              </div>
              <!-- <v-col cols="12" sm="12" md="12" lg="12"> -->
              <infinite-loading :identifier="infiniteId" @infinite="getVideos">
                <div slot="spinner">
                  <v-progress-circular
                    indeterminate
                    color="red"
                  ></v-progress-circular>
                </div>
                <div slot="no-results"></div>
                <span slot="no-more"></span>
                <div slot="error" slot-scope="{ trigger }">
                  <v-alert prominent type="error">
                    <v-row align="center">
                      <v-col class="grow">
                        <div class="title">Error!</div>
                        <div>
                          Something went wrong, but don’t fret — let’s give it
                          another shot.
                        </div>
                      </v-col>
                      <v-col class="shrink">
                        <v-btn @click="trigger">Take action</v-btn>
                      </v-col>
                    </v-row>
                  </v-alert>
                </div>
              </infinite-loading>
              <!-- </v-col> -->
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <signin-modal
      :openModal="signinDialog"
      :details="details"
      @closeModal="signinDialog = false"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import InfiniteLoading from 'vue-infinite-loading'

import VideoService from '@/services/VideoService'
import SubscriptionService from '@/services/SubscriptionService'
import FeelingService from '@/services/FeelingService'
import HistoryService from '@/services/HistoryService'

import SigninModal from '@/components/SigninModal'
import AddComment from '@/components/comments/AddComment'
import CommentList from '@/components/comments/CommentList'

export default {
  data: () => ({
    loading: false,
    loaded: false,
    errored: false,
    videoLoading: true,
    subscribed: false,
    subscribeLoading: false,
    showSubBtn: true,
    feeling: '',
    video: {},
    videoId: '',
    videos: [],
    page: 0,
    infiniteId: +new Date(),
    truncate: true,
    url: process.env.VUE_APP_URL,
    signinDialog: false,
    details: {}
  }),
  computed: {
    ...mapGetters(['currentUser', 'getUrl', 'isAuthenticated'])
  },
  methods: {
    async getVideo(id) {
      this.errored = false
      this.videoLoading = true
      this.video = {}
      try {
        const video = await VideoService.getById(id)
//console.log(video);
        if (!video) return this.$router.push('/')
      
        this.video = video.data
       // console.log( this.video )
      } catch (err) {
        this.errored = true
        console.log(err)
      } finally {
        this.videoLoading = false
        this.checkSubscription(this.video.channel.name+"@"+this.video.channel.host)
        this.checkFeeling(this.video.shortUUID)
      }
      if (this.currentUser && this.currentUser.id === this.video.account.id) {
        this.showSubBtn = false
      } else {
        this.showSubBtn = true
      }

      if (!this.isAuthenticated) return

      if (        this.video.account.id.toString() !== this.currentUser.id.toString() &&        this.video.privacy.id !== 1      )        return this.$router.push('/')

      const data = {
        type: 'watch',
        videoId: this.video.shortUUID
      }

      await HistoryService.createHistory(data).catch((err) => console.log(err))
    },
    async getVideos($state) {
      this.errored = false
      if (!this.loaded) {
        this.loading = true
      }
      const videos = await VideoService.getAll('public', 
      
      { 
                start: this.page,
        count:10
         })
        .catch((err) => {
          console.log(err)
          this.errored = true
        })
        .finally(() => (this.loading = false))

      if (typeof videos === 'undefined') return

      if (videos.data.data.length) {
        this.page += 10

        this.videos.push(...videos.data.data)
        if ($state) {
          $state.loaded()
        }

        this.loaded = true
      } else {
        if ($state) {
          $state.complete()
        }
      }
    },
    async checkSubscription(id) {
      if (!this.isAuthenticated) return

      this.loading = true
      const sub = await SubscriptionService.checkSubscription("aa",id )
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.loading = false
        })

      if (!sub) return
//console.log(Object.keys(sub.data))
//console.log(Object.keys(sub.data).includes(id))
      if (!Object.keys(sub.data).includes(id)) this.subscribed = false
      else this.subscribed = true
    },
    async checkFeeling(id) {
      if (!this.isAuthenticated) return

      this.loading = true
      const feeling = await FeelingService.checkFeeling({ videoId: id })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.loading = false
        })
//console.log(feeling.data)
      if (!feeling.data.rating==='like') return

      if (feeling.data.rating === 'like') this.feeling = 'like'
      else if (feeling.data.rating === 'dislike') this.feeling = 'dislike'
    },
    async createFeeling(type) {
      if (!this.isAuthenticated) {
        this.signinDialog = true
        this.details = {
          title:
            type === 'like' ? 'Like this video?' : "Don't like this video?",
          text: 'Sign in to make your opinion count.'
        }
        return
      }
      let feeltype=type;
      console.log(this.feeling);
      switch (true) {
        case type === 'like' && this.feeling === '':
          this.feeling = 'like'
          this.video.likes++
          // console.log('new like')
          break
        case type === 'like' && this.feeling === type:
          this.feeling = ''
          feeltype='none';
          this.video.likes--
          // console.log('remove like')
          break
        case type === 'like' && this.feeling === 'dislike':
          this.feeling = 'like'
          this.video.dislikes--
          this.video.likes++
          // console.log('change to like')
          break
        case type === 'dislike' && this.feeling === '':
          this.feeling = 'dislike'
          this.video.dislikes++
          // console.log('new dislike')
          break
        case type === 'dislike' && this.feeling === type:
          this.feeling = ''
          this.video.dislikes--
          feeltype='none';
          // console.log('remove dislike')
          break
        case type === 'dislike' && this.feeling === 'like':
          this.feeling = 'dislike'
          this.video.likes--
          this.video.dislikes++
        // console.log('change to dislike')
      }

      const feeling = await FeelingService.createFeeling({
        videoId: this.video.shortUUID,
        rating:feeltype
      }).catch((err) => {
        console.log(err)
      })

      if (!feeling) return
    },
    async subscribe() {
      if (!this.isAuthenticated) {
        this.signinDialog = true
        this.details = {
          title: 'Want to subscribe to this channel?',
          text: 'Sign in to subscribe to this channel.'
        }
        return
      }
      this.subscribeLoading = true
      const sub = await SubscriptionService.createSubscription({
        channelId: this.video.chennel.id
      })
        .catch((err) => console.log(err))
        .finally(() => {
          this.subscribeLoading = false
        })

      if (!sub) return

      if (!sub.data.id) {
        this.subscribed = false
        this.video.account.id.subscribers--
      } else {
        this.subscribed = true
        this.video.account.id.subscribers++
      }
    },
    async updateViews(id) {
      const views = await VideoService.updateViews(id).catch((err) => {
        console.log(err)
      })
      if (!views) return

      this.video.views++
    },
    play(e) {
      console.log(e)
    },
    actions() {
      this.getVideo()
    },
    show(event) {
      if (event.target.innerText === 'SHOW MORE') {
        this.truncate = false
        event.target.innerText = 'SHOW LESS'
      } else {
        this.truncate = true
        event.target.innerText = 'SHOW MORE'
      }
    },
    truncateText(string = '', num) {
      if (string.length <= num) {
        return string
      }
      return string.slice(0, num)
    },
    dateFormatter(date) {
      return moment(date).fromNow()
    }
  },
  components: {
    AddComment,
    CommentList,
    SigninModal,
    InfiniteLoading
  },
  mounted() {
    this.getVideo(this.$route.params.id)
    //if (this.isAuthenticated) this.updateViews(this.$route.params.id)
  },
  beforeRouteUpdate(to, from, next) {
    this.page = 0
    ;(this.loading = false), (this.loaded = false), (this.videos = [])
    this.infiniteId += 1
    this.getVideo(to.params.id)
    next()
  }
}
</script>
<style>
.video-page{width:100%}
@media only screen and (max-width: 767px){.youtube-player{position:sticky;top:0;left:0;z-index:400}}.youtube-player .iframe-player{position:relative;overflow:hidden;width:100%;padding-top:56.25%}
.youtube-player .iframe-player iframe{position:absolute;top:0;left:0;bottom:0;right:0;width:100%;height:100%}.video-description{padding:0 20px}@media only screen and (min-width: 767px){.video-description{padding:5px 20px;margin-top:20px;border-radius:20px}}.video-description .title{font-size:18px;margin-bottom:10px}.video-description .description{font-size:14px;opacity:.7;word-wrap:break-word;white-space:pre-wrap;padding-top:8px;overflow:hidden}
.video-description .description.hidden{height:0}.video-description .description.show{height:auto}.video-description .statistics{font-size:12px;font-weight:300;display:flex;align-items:center}@media only screen and (min-width: 767px){.video-description .statistics{padding-bottom:10px}}.video-description .statistics .divider{width:4px;height:4px;border-radius:50%;background-color:#fff;content:"";margin:0px 8px}.video-description .statistics .show-more-btn{font-weight:400;margin-left:10px;text-decoration:underline;cursor:pointer}.video-description .statistics .show-more-btn.hidden{display:none}.video-description .statistics .show-more-btn.show{display:inline-block}.video-description .show-less-btn{font-weight:400;margin-top:10px;text-decoration:underline}.video-description .show-less-btn.hidden{display:none}.video-description .show-less-btn.show{display:block}.channel-details{width:calc(100% - 30px);display:flex;padding:12px 15px;align-items:center;justify-content:space-between}@media only screen and (min-width: 767px){.channel-details{width:calc(100% - 580px);margin-left:220px}}.channel-details .left{display:flex;align-items:center;justify-content:space-around;max-width:100%}.channel-details .left .channel-dp{width:40px;height:40px;background-position:center;background-repeat:none;background-size:cover;content:"";border-radius:50%}.channel-details .left .title{margin-left:10px;font-size:14px;font-weight:400}.channel-details .left .subscribers-count{margin-left:10px;font-size:12px;font-weight:300;opacity:.7;vertical-align:middle}.channel-details .subscribe-btn{padding:8px 12px;font-size:14px;font-weight:500;background-color:#fff;color:#0f0f0f;border-radius:20px}.more-details{width:calc(100% - 30px);display:flex;flex-direction:row;padding:12px 15px;margin-bottom:20px;scrollbar-width:none;border-bottom:1px solid rgba(228,228,228,.1294117647);overflow:scroll;white-space:nowrap;position:relative}@media only screen and (min-width: 767px){.more-details{width:calc(100% - 580px);margin-left:220px}}.more-details .tag{display:flex;justify-content:center;align-items:center;width:100%;padding:8px 15px;color:#fff;border-radius:20px;font-size:14px;vertical-align:middle;margin-right:10px;text-wrap:nowrap;white-space:nowrap}.more-details .tag:last-child{margin-right:0}.more-details .tag .icon{height:18px;vertical-align:middle}.more-details .tag .icon.margin-right{margin-right:10px}.more-details .tag .icon.margin-left-20{margin-left:20px}.more-details .tag .icon.padding-right{padding-right:10px}.more-details .tag .icon.border-right{border-right:1px solid rgba(228,228,228,.1294117647)}.more-details .tag .icon.flipped{transform:scaleX(-1)}.more-details .tag .divider{opacity:.5;font-size:18px;font-weight:normal}

</style>
<style lang="scss">
video {
  max-width: 100%;
}

.grey-color {
  color: #7f7f7f !important;
}

#btns {
  border-bottom: 1px solid #e0d8d8;
}

button.v-btn.remove-hover-bg {
  background-color: initial !important;
  &:hover {
    background-color: #f9f9f9;
  }
}
</style>
